import Tim from "tim-js-sdk";
import TIMUploadPlugin from "tim-upload-plugin";

let tim  = Tim.create({
	SDKAppID: parseInt(process.env.VUE_APP_TIM_ID)
});
tim.registerPlugin({
	'tim-upload-plugin': TIMUploadPlugin
});
tim.setLogLevel(0);

export default tim;
